type Recurring = {
  enabled: boolean;
  startDate: string;
  frequency: "DAILY" | "WEEKLY";
  daysOfWeek?: number[]; // 0-6 (Mon-Sun)
  endCondition?: {
    type: "NEVER" | "UNTIL_DATE" | "COUNT";
    endDate?: string;
    occurrences?: number;
  };
};

function formatMonthDay(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return iso;
  return new Intl.DateTimeFormat("en-US", {
    month: "long",
    day: "2-digit",
    timeZone: "UTC",
  }).format(d);
}

export function formatSchedule(recurring: unknown): string | null {
  const r = recurring as Partial<Recurring> | null | undefined;
  if (!r || r.enabled !== true) return null;

  const from = r.startDate ? formatMonthDay(r.startDate) : null;
  const endType = r.endCondition?.type;

  let suffix = "";
  if (endType === "COUNT" && typeof r.endCondition?.occurrences === "number") {
    suffix = ` for ${r.endCondition.occurrences} occurrences`;
  }

  if (r.frequency === "DAILY") {
    return from ? `Daily from ${from}${suffix}` : `Daily${suffix}`;
  }

  if (r.frequency === "WEEKLY") {
    const dayNames = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
    const days = Array.isArray(r.daysOfWeek) ? r.daysOfWeek : [];
    const pretty = days
      .filter((d) => Number.isInteger(d) && d >= 0 && d <= 6)
      .map((d) => dayNames[d] ?? `${d}`)
      .join(",");

    const weekly = `Weekly${pretty ? ` (${pretty})` : ""}`;
    if (!from) return `${weekly}${suffix}`;
    return `${weekly} from ${from}${suffix}`;
  }

  return from ? `Recurring from ${from}${suffix}` : `Recurring${suffix}`;
}


